import { apiCall } from 'library';

export function getErrorOrders() {
  return apiCall('/api/mgmt/orders/errors');
}

export function resetErrorOrders(ids) {
  return apiCall('/api/mgmt/orders/errors/reset', {
    method: 'PUT',
    body: JSON.stringify({ ids }),
  });
}

export function assignSapId(orderId, sapId) {
  return apiCall('/api/mgmt/order/assign-sap-id', {
    method: 'POST',
    body: JSON.stringify({id: orderId, sap_id: sapId})
  });
}